<template>
	<el-dialog
		:modal-append-to-body="true"
		:append-to-body="true"
		:title="$t('themelist.themeMachine')"
		:visible.sync="dialogVisible"
		v-dialogDrag
		:close-on-click-modal="false"
		top="8vh"
		custom-class="cmcMachine"
		width="700px">
		<div :element-loading-text="$t('common.request')">
			<div style="width: 100%; margin-bottom: 20px">
				<div class="el-search" style="border-radius: 0">
					<div class="el-left">
						<el-button
							type="primary"
							size="small"
							icon="el-icon-plus"
							@click="$emit('add-machine', 2)">
							{{ $t("common.add") }}
						</el-button>
					</div>
					<div class="el-right">
						<el-button type="danger" size="small" icon="el-icon-delete" @click="$emit('remove-machine', 0)">
							{{ $t("advertGroupRela.remove") }}
						</el-button>
					</div>
				</div>
			</div>

			<el-table
				v-loading="loadingZhutiMachine"
				:data="machineData"
				border
				style="width: 100%"
				@selection-change="$emit('selection-machine', $event)">
				<el-table-column type="selection" width="40" :align="'center'"></el-table-column>
				<el-table-column
					prop="equipmentNo"
					:label="$t('machine.equipmentNo')"
					:fixed="'left'"
					:align="'center'"></el-table-column>
				<el-table-column
					prop="equipmentName"
					:label="$t('machine.name')"
					:align="'center'"></el-table-column>
				<el-table-column fixed="right" :label="$t('common.operate')" min-width="140" :align="'center'">
					<template slot-scope="scope">
						<el-button
							type="danger"
							icon="el-icon-delete"
							size="mini"
							style="padding: 7px"
							@click="$emit('remove-machine', 0, scope.row.id)">
							{{ $t("advertGroupRela.remove") }}
						</el-button>
					</template>
				</el-table-column>
			</el-table>

			<div v-if="themeMachinePage.totalSize > 0" style="display: flow-root; margin-top: 20px">
				<el-pagination
					background
					layout="total, prev, pager, next"
					:current-page="themeMachinePage.pageIndex"
					:total="themeMachinePage.totalSize"
					:page-size="themeMachinePage.pageSize"
					@current-change="$emit('theme-machine-page-change', $event)"
					style="margin-top: 0"></el-pagination>
			</div>
		</div>
	</el-dialog>
</template>

<script>
export default {
	name: "ThemeMachineDialog",
	props: {
		visible: {
			type: Boolean,
			required: true,
		},
		loadingZhutiMachine: {
			type: Boolean,
			required: true,
		},
		machineData: {
			type: Array,
			required: true,
		},
		themeMachinePage: {
			type: Object,
			required: true,
		},
	},
	computed: {
		dialogVisible: {
			get() {
				return this.visible;
			},
			set(value) {
				this.$emit("update:visible", value);
			},
		},
	},
};
</script>
